import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
export function validateEmail(email) {
  var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}
export function validateEmailBackend(_x) {
  return _validateEmailBackend.apply(this, arguments);
}

function _validateEmailBackend() {
  _validateEmailBackend = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(email) {
    var encodedEmail;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            encodedEmail = encodeURI(email);
            return _context.abrupt("return", fetch("https://services.customer-iam.dfds.cloud/services-email-validation-api/api/Validation/format/".concat(encodedEmail), {
              method: 'GET'
            }).then(function (response) {
              return response.status === 200;
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _validateEmailBackend.apply(this, arguments);
}